module.exports = __webpack_public_path__ + "static/media/logistics-default-bg.480dde1c.jpg";